import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/analytics";
import "firebase/compat/database";
import "firebase/compat/storage";
import { getPerformance } from "firebase/performance";
import { initializeFirestore } from "firebase/firestore/lite";

const configOptions = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSENGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
};

const app = firebase.initializeApp(configOptions);
const analytics = firebase.analytics();

getPerformance(app);
firebase.firestore().settings({ experimentalForceLongPolling: true });
initializeFirestore(app, {
  ignoreUndefinedProperties: true
});
const getCurrentUser = function getCurrentUser() {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject);
  });
};

const db = firebase.firestore();
const database = firebase.database();
const storage = firebase.storage();
const auth = firebase.auth;

const currentUser = auth.currentUser;

// firebase collections
const usersCollection = db.collection("users");
const activiteesCollection = db.collection("activitees");
const activitiesCollection = db.collection("activities");
const commentsCollection = db.collection("comments");
const likesCollection = db.collection("likes");

const fieldValue = firebase.firestore.FieldValue;

export {
  db,
  database,
  auth,
  currentUser,
  activiteesCollection,
  activitiesCollection,
  storage,
  usersCollection,
  commentsCollection,
  likesCollection,
  configOptions,
  fieldValue,
  analytics,
  getCurrentUser
};
